import { Typography } from '@mui/material';
import { ILooseFruitData, WeightUnitEnum } from 'interfaces/erms';
import { FC, useEffect, useState } from 'react';
import { useAppSelector } from 'store/hooks';
import { mapViewSelector } from 'store/slices/mapViewSlice';
import ContainerBox from '../../components/ContainerBox';
import LooseFruitLineChart from './LooseFruitLineChart';
import SelectLooseFruitUnit from './SelectLooseFruitUnit';

interface LooseFruitBoxProps {
  area: number;
  totalTree: number;
  looseFruitData: ILooseFruitData[];
  hoverDatePoint: string;
}

const LooseFruitBox: FC<LooseFruitBoxProps> = ({ area, totalTree, looseFruitData, hoverDatePoint }) => {
  const [looseFruitUnit, setLooseFruitUnit] = useState<WeightUnitEnum>(WeightUnitEnum.METRIC_TONNE);

  const { levelId } = useAppSelector(mapViewSelector);

  // reset yield options when changing levelId
  useEffect(() => {
    setLooseFruitUnit(WeightUnitEnum.METRIC_TONNE);
  }, [levelId]);

  return (
    <ContainerBox>
      <Typography fontSize="16px" mb="8px" fontWeight={600}>
        Yield
      </Typography>
      <SelectLooseFruitUnit
        looseFruitUnit={looseFruitUnit}
        setLooseFruitUnit={setLooseFruitUnit}
        area={area}
        totalTree={totalTree}
      />
      <LooseFruitLineChart
        looseFruitData={looseFruitData}
        looseFruitUnit={looseFruitUnit}
        area={area}
        totalTree={totalTree}
        hoverDatePoint={hoverDatePoint}
      />
    </ContainerBox>
  );
};

export default LooseFruitBox;
